import { Controller } from "@hotwired/stimulus"

// Deben alinearse con packs/fitness/app/views/shared/_horizontal_date_strip.html.erb
const CARD_SELECTED = "border-button-primary-bg text-button-primary-bg"
const CARD_SELECTABLE =
  "border-primary-light-color/30 bg-background hover:border-button-primary-bg/60 hover:bg-button-primary-bg/10 text-primary-color active:scale-[0.97] active:opacity-90 transition-[transform,opacity,colors] duration-150 motion-reduce:active:scale-100 touch-manipulation"

const ALL_CARD_STATE_CLASSES = [...new Set(`${CARD_SELECTED} ${CARD_SELECTABLE}`.split(/\s+/))].filter(Boolean)

export default class extends Controller {
  static targets = ["loadingOverlay"]
  static values = {
    initialDate: String,
    slotsFrameId: { type: String, default: "public_scheduling_slots" }
  }

  connect() {
    this._bindShowLoading = this._onBeforeFetchRequest.bind(this)
    this._bindHideLoading = this._onFrameLoad.bind(this)
    this._bindHideOnError = this._onFetchError.bind(this)
    this._bindHideOnFrameMissing = this._onFrameMissing.bind(this)

    document.documentElement.addEventListener("turbo:before-fetch-request", this._bindShowLoading)
    document.documentElement.addEventListener("turbo:fetch-request-error", this._bindHideOnError)

    // Capture on controller root: survives if Turbo swaps the <turbo-frame> node; document-level bubble was unreliable for hiding.
    this.element.addEventListener("turbo:frame-load", this._bindHideLoading, true)
    this.element.addEventListener("turbo:frame-missing", this._bindHideOnFrameMissing, true)

    if (this.initialDateValue) {
      this._applySelectedDate(this.initialDateValue)
    }
  }

  disconnect() {
    document.documentElement.removeEventListener("turbo:before-fetch-request", this._bindShowLoading)
    document.documentElement.removeEventListener("turbo:fetch-request-error", this._bindHideOnError)

    this.element.removeEventListener("turbo:frame-load", this._bindHideLoading, true)
    this.element.removeEventListener("turbo:frame-missing", this._bindHideOnFrameMissing, true)
  }

  selectDate(event) {
    const link = event.currentTarget
    const date = link.dataset.date
    if (!date) return

    this._applySelectedDate(date)
  }

  _turboFrameHeaderFromEvent(event) {
    const headers = event.detail?.fetchOptions?.headers
    if (!headers) return null
    if (typeof headers.get === "function") return headers.get("Turbo-Frame")
    return headers["Turbo-Frame"]
  }

  _onBeforeFetchRequest(event) {
    if (this._turboFrameHeaderFromEvent(event) !== this.slotsFrameIdValue) return

    this._setLoadingVisible(true)
  }

  _onFrameLoad(event) {
    if (event.target?.id !== this.slotsFrameIdValue) return

    this._setLoadingVisible(false)

    const meta = event.target.querySelector("[data-public-scheduling-slot-meta]")
    const date = meta?.dataset?.date
    if (date !== undefined) {
      this._applySelectedDate(date)
    }
  }

  _onFrameMissing(event) {
    if (event.target?.id !== this.slotsFrameIdValue) return

    this._setLoadingVisible(false)
  }

  _onFetchError(event) {
    if (this._turboFrameHeaderFromEvent(event) !== this.slotsFrameIdValue) return

    this._setLoadingVisible(false)
  }

  _setLoadingVisible(visible) {
    if (!this.hasLoadingOverlayTarget) return

    this.loadingOverlayTarget.classList.toggle("hidden", !visible)
    this.loadingOverlayTarget.setAttribute("aria-busy", visible ? "true" : "false")
  }

  disableSubmit(event) {
    const form = event.target
    if (!(form instanceof HTMLFormElement)) return

    const submit = form.querySelector('button[type="submit"], input[type="submit"]')
    if (submit) submit.disabled = true
  }

  _applySelectedDate(date) {
    this.element.querySelectorAll(`a[data-turbo-frame="${this.slotsFrameIdValue}"][data-date]`).forEach((el) => {
      el.classList.remove(...ALL_CARD_STATE_CLASSES)

      const isSelected = date && el.dataset.date === date
      if (isSelected) {
        el.classList.add(...CARD_SELECTED.split(/\s+/))
      } else {
        el.classList.add(...CARD_SELECTABLE.split(/\s+/))
      }

      const dot = el.querySelector("[data-date-dot]")
      if (dot) {
        dot.classList.toggle("hidden", Boolean(isSelected))
      }
    })
  }
}
